<template>
    <div class="poster">
        <div class="title">
            <p>违规预警</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.data" placeholder="请输入编号ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.data" placeholder="请输入平台名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="违规安装" name="0"></el-tab-pane>
                    <el-tab-pane label="违规售后" name="1"></el-tab-pane>
                    <el-tab-pane label="违规销售" name="2"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tabload">
                    <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="title" label="危机类型" align="center"> </el-table-column>
                    <el-table-column prop="receive_name" label="品牌名称" align="center"> </el-table-column>
                    <el-table-column prop="receive_phone" label="平台名称" align="center"> </el-table-column>
                    <el-table-column prop="express_no" label="内容" align="center"> </el-table-column>
                    <el-table-column prop="express_no" label="预警时间" align="center"> </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="detail(scope.row.id)">详情</el-link>
                                <el-link type="primary" @click="detail(scope.row.id)">编辑</el-link>
                                <el-link type="primary" @click="detail(scope.row.id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <Detail ref="refDetail"></Detail>
        <Operate ref="refOperate"></Operate>
        <CreateOrEdit ref="refCreateOrEdit" @selectProduct="selectProduct"></CreateOrEdit>
        <InstallProduct ref="refInstallProduct"></InstallProduct>
        <ServeProduct ref="refServeProduct"></ServeProduct>
        <ProductMonitor ref="refProductMonitotr"></ProductMonitor>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CreateOrEdit from "@/components/Modules/InstallSale/CreateOrEdit.vue";
import Detail from "@/components/Modules/InstallSale/Detail.vue";
import Operate from "@/components/Modules/ProductManagement/Operate.vue";
import ServeProduct from "@/components/Modules/MarketingManagement/ServeProduct.vue";
import InstallProduct from "@/components/Modules/MarketingManagement/InstallProduct.vue";
import ProductMonitor from "@/components/Modules/MarketingManagement/ProductMonitor.vue";
export default {
    components: {
        Detail,
        Operate,
        CreateOrEdit,
        ServeProduct,
        InstallProduct,
        ProductMonitor,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            selType: 1,
            tableData: [],
            formInline: {
                type: "",
                data: "",
            },
            activeName: "0",
            type: "",
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            posterList: "commodity/posterList",
        }),
        selectProduct(type) {
            if (type == "install") {
                this.$refs.refInstallProduct.bindData();
            } else if (type == "serve") {
                this.$refs.refServeProduct.bindData();
            } else if (type == "monitotr") {
                this.$refs.refProductMonitotr.bindData();
            }
        },
        create() {
            this.$refs.refCreateOrEdit.dialogVisible = true;
        },
        postInfo(row) {
            console.log(row);
            this.$refs.refPostPoster.dialogVisible = true;
            this.$refs.refPostPoster.rowData = row;
        },
        operate(id) {
            this.$refs.refOperate.dialogVisible = true;
        },
        detail(id) {
            this.$refs.refDetail.dialogVisible = true;
        },
        getList(tag) {
            this.tabload = true;
            if (this.formInline.type != 0 && !this.formInline.data) {
                this.$message.warning("请填写活动名称！");
            }
            let opt = {
                token: this.getToken,
                type: this.formInline.type == 0 ? null : this.formInline.type, //0-忽略此条件 1-活动名称 2-快递单号 3-联系人
                data: this.formInline.data, //输入的数据
                status: this.activeName == 0 ? null : this.activeName, //状态 1-未邮寄 2-已邮寄
                page_size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
            };
            this.posterList(opt).then((res) => {
                this.tabload = false;
                if (res.code == 1) {
                    this.tableData = res.data.data;
                    this.total = res.data.total ? res.data.total : 0;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                type: "0",
                data: "",
            };
            this.getList(1);
        },
        handleClick() {
            // console.log(this.activeName);
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__active-bar {
        width: 120px;
    }

    ::v-deep .el-tabs__item {
        width: 120px;
        text-align: center;
        padding: 0;
    }

    .title {
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
</style>